<template>
  <div class="goal-list-datepicker">
    <span class="ml-1 mr-1">
      <b-form-datepicker
        v-model="_value"
        value-as-date
        hide-header
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        class="goal-list-datepicker__label"
        menu-class="goal-list-datepicker__menu">
        <template #button-content>
          <span
            class="material-icons calendar-icon">
            calendar_month
          </span>
        </template>
      </b-form-datepicker>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Date],
      required: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss">
.goal-list-datepicker {
  display: flex;
  justify-content: center;
  align-items: center;

  &__label {
    background-color: transparent !important;
    flex-direction: row-reverse;
    & > button {
      margin: 0;
      padding: 0;
      color: $grey04 !important;
    }

    label {
      font-weight: bold;
      padding: 8px 4px;

    }
  }

  &__menu {
    top: 40px !important;
    transform: translate(-35%, 0%) !important;
  }
}
</style>